import React from 'react'
import { useDispatch } from 'react-redux'
import { CONSULTING_FORM_ID } from '@/components/composed/landingBlocks/LandingApplyingLeasingOfferForm/components/MiniConsultingForm'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { FinancingConsultingModal } from '@/components/composed/modals'
import { Button } from '@/components/ui'
import { asyncScrollIntoView } from '@/utils/helpers'
import { messages } from './messages'
import type { IConsultingActionButtonProps } from './types'

addModalToWellKnown({ FinancingConsultingModal })

export const ConsultingActionButton: React.FC<IConsultingActionButtonProps> = ({ mustScrollToForm }) => {
  const dispatch = useDispatch()

  const onClick = () => {
    if (mustScrollToForm) {
      asyncScrollIntoView(`#${CONSULTING_FORM_ID}`)

      return
    }

    dispatch(openModal({ options: { dialogId: 'FinancingConsultingModal' } }))
  }

  return (
    <Button modifiers={['outline', 'full-width-mobile']} onClick={onClick}>
      {messages.button}
    </Button>
  )
}
